import { render, staticRenderFns } from "./account-dob.vue?vue&type=template&id=ece6b330&"
import script from "./account-dob.vue?vue&type=script&lang=js&"
export * from "./account-dob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports